import type { FunctionComponent } from "react";
import { RejectSocialModalPartial } from "../../../../partials/admin/menus/socials/reject-social-modal.admin.partials";

export const RejectSocialModalAdminScreen: FunctionComponent = () => {
	return <RejectSocialModalPartial />;
};
